function getNewConnectionTerminalPoint(cell, x, y) {
  let terminalX, terminalY;
  const geometry = cell.geometry;

  const xRange = [geometry.x, geometry.x + geometry.width];
  const yRange = [geometry.y, geometry.y + geometry.height];

  if (isInRange(x, xRange).result) {
    terminalX = 0.5;

    if (isInRange(y, yRange).over) {
      terminalY = 0;
    } else {
      terminalY = 1;
    }
  } else {
    terminalY = 0.5;

    if (isInRange(x, xRange).over) {
      terminalX = 0;
    } else {
      terminalX = 1;
    }
  }

  return [terminalX, terminalY];
}

function isInRange(num, range) {
  return {
    result: num >= range[0] && num <= range[1],
    under: num < range[0],
    over: num > range[1]
  };
}

export {getNewConnectionTerminalPoint};
